import type { CustomerDetailsSchemas } from "@wayflyer/api-types";

export enum ConnectorCategory {
  ECOMMERCE = "SHOPPING",
}

export enum UploadDocumentType {
  MANAGEMENT_ACCOUNTS = "management-accounts",
  BALANCE_SHEET = "balance-sheet",
  PROFIT_AND_LOSS = "profit-and-loss",
  SUSA = "susa",
  POOL_BANCARIO = "pool-bancario",
  CIRBE = "cirbe",
  CASH_FLOW_FORECAST = "cash-flow-forecast",
  COMPANY_DEBT_AGREEMENT = "debt-agreement",
}

export type BusinessModelData = CustomerDetailsSchemas.BusinessModel | null;
